export default __webpack_public_path__ + "static/media/ic_settings.28c2b0d8.svg";